<template>
  <div class="container">
    <!-- アイコン -->
    <div class="complete-icon">
      <img
        :src="iconSrc"
        :alt="iconAlt"
        class="complete-icon-img"
      />
    </div>

    <!-- タイトル -->
    <h2 class="complete-title">{{ $t(titleKey) }}</h2>

    <!-- 本文 -->
    <div class="complete-body">
      <p>{{ $t('age_verification__complete__body') }}</p>
    </div>

    <!-- フッター -->
    <div class="footer">
      <div class="social-icons">
        <a
          href="https://x.com/REALITY_app"
          class="social-link"
          aria-label="X"
        >
          <img
            src="/img/campaign/reality_con_2025/x_logo.png"
            alt="X"
            class="social-icon-img"
          />
        </a>
        <a
          href="https://discord.com/invite/wBgtpCq"
          class="social-link"
          aria-label="Discord"
        >
          <img
            src="/img/campaign/reality_con_2025/discord_logo.png"
            alt="Discord"
            class="social-icon-img"
          />
        </a>
        <a
          href="https://www.youtube.com/@REALITY_app"
          class="social-link"
          aria-label="YouTube"
        >
          <img
            src="/img/campaign/reality_con_2025/youtube_logo.png"
            alt="YouTube"
            class="social-icon-img"
          />
        </a>
      </div>
      <div class="copyright">&copy;REALITY, inc.</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AgeVerificationCompleteBase extends Vue {
  @Prop({ type: String, required: true })
  iconSrc!: string

  @Prop({ type: String, required: true })
  iconAlt!: string

  @Prop({ type: String, required: true })
  titleKey!: string

}
</script>

<style scoped>
.container {
  padding: 32px 16px;
  max-width: 375px;
  margin: 0 auto;
  font-size: 14px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.complete-icon-img {
  width: 80px;
  height: 80px;
}

.complete-title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  line-height: 30px;
  letter-spacing: 0.15px;
  margin: 0;
  color: #0f0f0f;
}

.complete-body {
  align-self: stretch;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #0f0f0f;
}

.complete-body p {
  margin: 0;
}

.footer {
  margin-top: auto;
  padding-bottom: 16px;
  padding-top: 40px;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 16px;
}

.social-link {
  text-decoration: none;
}

.social-icon-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.copyright {
  text-align: center;
  color: #808080;
  font-size: 14px;
}
</style>
